module.exports = __webpack_public_path__ + "img/qr_code4.aa854327.png";